module.exports = __webpack_public_path__ + "img/fall-2@3x.f3954978.png";